import { useQuery } from "react-query";
import AreaScreen from "..";
import Context from "../../../context";
import api from "../../../api";
import values from "../../../values";
import { useContext, useEffect, useState } from "react";
import { TModal } from "../../../types/common.type";
import utils from "../../../utils";
import {
  ICreateAndUpdateArea,
  IRequestArea,
} from "../../../types/area.interface";

const CompanyContainer = () => {
  const { userInfo } = useContext(Context?.AppContext);
  const [showModal, setShowModal] = useState<TModal>();
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedArea, setSelectedArea] = useState<ICreateAndUpdateArea>();
  const [requestArea, setRequestArea] = useState<IRequestArea>({
    page: 1,
    limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
    company: userInfo?.data?.result?._id,
  });

  useEffect(() => {
    setRequestArea({ ...requestArea, company: userInfo?.data?.result?._id });
  }, [userInfo?.data?.result]);
  const resultArea = useQuery(
    [values.useQueryKeys.getAllArea, requestArea],
    () =>
      api.getMethod.common.findArea({
        ...requestArea,
      }),
    { enabled: userInfo?.data?.result?._id !== undefined }
  );

  const updateArea = async (Area: ICreateAndUpdateArea) => {
    setLoading(true);
    const result = await api.putMethod.company.updateArea(Area);
    if (result) {
      resultArea.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      return false;
    }
  };
  const createArea = async (AreaInfo: ICreateAndUpdateArea) => {
    setLoading(true);
    const result = await api.postMethod.company.createArea(AreaInfo);
    if (result) {
      resultArea.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      setLoading(false);
      return false;
    }
  };
  const removeArea = async (_id: string) => {
    setLoading(true);
    const result = await api.deleteMethod.company.deleteArea(_id);
    if (result) {
      resultArea.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      setLoading(false);
      return false;
    }
  };

  return (
    <Context.AreaScreen.Provider
      value={{
        resultArea,
        requestArea,
        setRequestArea,
        showModal,
        setShowModal,
        selectedArea,
        setSelectedArea,
        loading,
        setLoading,
        updateArea,
        createArea,
        removeArea,
      }}
    >
      <AreaScreen />
    </Context.AreaScreen.Provider>
  );
};

export default CompanyContainer;
